// src/services/authService.js

export function decodeToken(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const binary = atob(base64);
    const bytes = new Uint8Array([ ...binary ].map(char => char.charCodeAt(0)));
    const payload = JSON.parse(new TextDecoder('utf-8').decode(bytes));
    return payload;
  } catch (error) {
    return null;
  }
}
